import { Clock, Award, Wrench, MessageSquareText } from "lucide-react";

const PUNTI = [
  { icon: Clock, val: "H24", txt: "Reperibili giorno e notte, festivi inclusi, in tutta la provincia di Rimini" },
  { icon: Award, val: "30 anni", txt: "Di esperienza nel settore idraulico" },
  { icon: Wrench, val: "3 settori", txt: "Civile, industriale e impianti speciali" },
  { icon: MessageSquareText, val: "3 canali", txt: "Telefono, WhatsApp ed email" },
];

export const PercheNoi = () => (
  <section className="bg-slate-900 text-white" data-testid="perche-noi-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-20 grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-4">
        <p className="text-xs font-bold uppercase tracking-wider text-sky-300">Perché sceglierci</p>
        <h2 className="mt-2 text-2xl sm:text-3xl font-bold tracking-tight">Esperienza vera, risposte rapide.</h2>
        <p className="mt-4 text-slate-300">Da 30 anni risolviamo guasti idraulici di ogni dimensione, dalla casa allo stabilimento.</p>
      </div>
      <div className="lg:col-span-8 grid sm:grid-cols-2 gap-4">
        {PUNTI.map(({ icon: Icon, val, txt }) => (
          <div key={val} className="rounded-2xl bg-white/5 border border-white/10 p-6 hover:bg-white/10 transition-colors">
            <Icon className="w-6 h-6 text-sky-300" />
            <p className="mt-4 text-3xl font-extrabold">{val}</p>
            <p className="mt-1 text-slate-300">{txt}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
